<script>
	export let width = '200px';
	export let height = '200px';

	let style = `width: ${width}; height: ${height}`;
</script>

<style>
	div {
		display: inline-block;
		margin: 0 auto;
	}
</style>

<div {style}>
	<svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 182 215.1127" width="85%">
		<g transform="matrix(1.25 0 0 -1.25 -423.45 573.68)">
			<g transform="matrix(.88889 0 0 .88889 46.686 42.042)">
				<path d="m410.68 276.2c74.577-0.33 81.076 32.963 81.076 42.906v148.89h-70.246l-10.765-25.614-10.75 25.614h-70.239v-148.89c0-9.943 6.487-43.236 81.068-42.906h-0.144z"/>
				<path d="m26.156 26.922v12.402c4.2425 2.4062 6.5723 5.2513 6.5723 8.8613v37.781c0 3.61-2.3298 6.4027-6.5723 8.8027v12.408h47.33v-12.5c-4.2588-2.4125-6.5762-5.2086-6.5762-8.8086v-28.777l28.443 50.086h11.691l28.432-50.086v28.777c0 3.6-2.3231 6.3961-6.5781 8.8086v12.5h47.336v-12.408c-4.2588-2.4-6.5703-5.1927-6.5703-8.8027v-37.781c0-3.61 2.3116-6.4551 6.5703-8.8613v-12.402h-49.99l-25.06 47.578-25.032-47.578h-50.002zm-0.05469 103.69v12.412c4.2575 2.3762 6.5781 5.1916 6.5781 8.7891v15.898c0.19875 11.612-4.9845 40.834 68.512 40.834 73.499 0 68.318-29.221 68.521-40.834v-15.898c0-3.5975 2.3244-6.4128 6.5781-8.7891v-12.412h-51.836v12.502c4.2512 2.3925 6.5684 5.2106 6.5684 8.8106v17.783c-0.19375 2.8 0.34047 14.021-29.832 14.021-30.165 0-29.643-11.221-29.824-14.021v-17.783c0-3.6 2.3091-6.418 6.5703-8.8106v-12.502h-51.836z" transform="matrix(.8 0 0 -.8 329.76 468)" fill="#f1b82d"/>
			</g>
		</g>
	</svg>
</div>
